






























import CancelButton from '@/components/buttons/CancelButton.vue'
import SolidPrimaryButton from '@/components/buttons/SolidPrimaryButton.vue'
import SubmitButton from '@/components/buttons/SubmitButton.vue'
import CardTitle from '@/components/CardTitle.vue'
import TenderService from '@/services/tender'
import { errorMessages } from '@/utils/helpers'
import { AxiosError } from 'axios'
import Vue from 'vue'

export default Vue.extend({
  name: 'CancelPublishedTenderButton',
  components: { CardTitle, SubmitButton, CancelButton, SolidPrimaryButton },
  model: { prop: 'showModal' },
  props: {
    procurementId: {
      type: Number,
      required: true,
      default: 0,
    },
  },
  data: () => ({
    dialog: false,
    reason: '',
  }),
  methods: {
    async submit(): Promise<void> {
      const loader = this.$loading.show()
      try {
        const response = await TenderService.cancelPublishedTender(this.procurementId, this.reason)
        if (response) {
          this.$emit('canceled')
          this.$toast.success(response.data.message)
          loader.hide()
          this.dialog = false
        }
      } catch (err: unknown) {
        const axiosError = err as AxiosError
        if (axiosError?.response?.data) {
          this.$toast.error(errorMessages(axiosError.response.data.message))
          return
        }
        this.$toast.error(this.$t('somethingWentWrong') as string)
      } finally {
        loader.hide()
      }
    },
  },
})
